import { PopupModal } from "react-calendly";
import { useFormEditorContext } from "../Contexts/FormEditorContext"; // adjust the import path as needed

export function CalendlyModal() {
    const { openCalendly, setOpenCalendly } = useFormEditorContext();

    return (
        <PopupModal
            url="https://calendly.com/ronath-buildform/30min?month=2024-09"
            onModalClose={() => setOpenCalendly(false)}
            open={openCalendly}
            //@ts-ignore
            rootElement={document.getElementById("root")}
        />
    );
}
